module.exports = __webpack_public_path__ + "static/img/govcard_white_11.eebb71f4.svg";